import React from "react";
import { IoClose } from "react-icons/io5";

interface Props {
  onClick?: any;
}

const CloseModalBtn = ({ onClick }: Props) => {
  return (
    <button
      className="no-style-btn"
      data-bs-dismiss="modal"
      type="button"
      id={"btn-close"}
      onClick={() => onClick && onClick()}
    >
      <IoClose />
    </button>
  );
};

export default CloseModalBtn;
